import { render, staticRenderFns } from "./RightFootSVG.vue?vue&type=template&id=6babaeef&scoped=true"
import script from "./RightFootSVG.vue?vue&type=script&lang=ts"
export * from "./RightFootSVG.vue?vue&type=script&lang=ts"
import style0 from "./RightFootSVG.vue?vue&type=style&index=0&id=6babaeef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6babaeef",
  null
  
)

export default component.exports